<template>

        <svg
        fill="currentColor"
        height="24px"
        width="24px"
        viewBox="0 0 319.002 319.002"
        xml:space="preserve"
        inkscape:version="1.4.2 (f4327f4, 2025-05-13)"
        xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
        xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:svg="http://www.w3.org/2000/svg">
        <g>
            <path
            d="m 318.022,122 c -2.353,-7.24 -8.611,-12.517 -16.146,-13.611 L 215.89,95.894 177.436,17.977 C 174.067,11.151 167.115,6.829 159.501,6.829 c -7.612,0 -14.565,4.322 -17.935,11.148 L 103.111,95.894 17.125,108.389 C 9.591,109.484 3.332,114.76 0.979,122 c -2.353,7.24 -0.391,15.188 5.062,20.502 l 62.221,60.65 -14.688,85.64 c -1.287,7.503 1.797,15.087 7.956,19.562 6.158,4.474 14.324,5.065 21.063,1.522 l 76.909,-40.434 76.909,40.434 c 2.926,1.538 6.121,2.297 9.305,2.297 4.146,0 8.273,-1.288 11.758,-3.819 6.159,-4.475 9.243,-12.059 7.956,-19.562 l -14.688,-85.64 62.221,-60.65 c 5.45,-5.313 7.412,-13.261 5.059,-20.502 z"
            />
        </g>
    </svg>

</template>